import { Client } from '@viddsee/server-api-client';
import { baseConfiguration } from './webcall-base';

export const playlistsApi = new Client.PlaylistsApi(baseConfiguration);
